<template>
  <FullPage>
    <Webview>
      <Header title="忘記密碼"></Header>
      <ResultPage :submit="back">
        系統已將密碼設定信件寄至<br>
        steve@gmail.com
      </ResultPage>
    </Webview>
  </FullPage>
</template>

<script>
export default {
  methods: {
    back() {
      this.$router.replace({ path: "/setting" });
    }
  }
}
</script>

<style>
</style>